import React, { useState } from 'react';
import { numberToWords } from './numberToWords';

const App: React.FC = () => {
  const [number, setNumber] = useState('');
  const [copied, setCopied] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumber(event.target.value);
  };

  const result = numberToWords(number);

  const copyToClipboard = () => {
    if (!result.ok) {
      return;
    }
    navigator.clipboard.writeText(result.text).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    });
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
      <div className="max-w-4xl w-full py-8 px-6">
        <h1 className="text-7xl text-center mb-8">Stora Tal</h1>
        <div className="mb-6">
          <input
            type="text"
            id="input-field"
            placeholder="Skriv in ett tal med siffror"
            autoComplete="off"
            autoFocus
            className="w-full px-4 py-3 border rounded-md outline-none focus:ring-blue-500 focus:border-blue-500 bg-gray-800 text-white text-xl"
            value={number}
            onChange={handleInputChange}
          />
        </div>
        <p className="text-2xl mb-8 break-words">{result.ok ? result.text : result.message}</p>
        <button
          className="btn btn-primary w-full text-xl"
          onClick={copyToClipboard}
          disabled={!result.ok}
        >
          Kopiera
        </button>
        {copied && (
          <p className="text-green-500 text-center mt-4">Kopierad!</p>
        )}
      </div>
    </div>
  );
};

export default App;